import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpTooltip from '@/app/common/components/HelpTooltip';

const formatAmount = (amount?: string) => {
  if (!amount) return '-';
  return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatDate = (value?: string) => {
  if (!value) return '-';
  return new Date(value).toLocaleString('fa-IR');
};

export const transactionsColumns = [
  {
    field: 'description',
    type: 'string',
    title: 'توضیحات',
    minWidth: 170,
    flex: 1
  },
  {
    field: 'sign',
    type: 'string',
    title: 'نوع تراکنش',
    width: 110,
    cellRenderer: (params: { value: number }) => (
      <span className={params.value === 1 ? 'text-success' : 'text-danger'}>
        {params.value === 1 ? 'واریز' : 'برداشت'}
      </span>
    )
  },
  {
    field: 'amount',
    type: 'string',
    title: 'مبلغ تراکنش (تومان)',
    width: 140,
    cellRenderer: (params: { value: string; data: { sign: number; is_gift?: boolean } }) => {
      const isDeposit = params.data?.sign === 1;
      const amountClass = isDeposit ? 'text-success' : 'text-danger';
      return (
        <span className={`d-inline-flex align-items-center gap-2 ${amountClass}`}>
          <span>
            {formatAmount(params.value)}
            {isDeposit ? '+' : '-'}
          </span>
          {params.data?.is_gift && (
            <HelpTooltip
              html="این اعتبار رو به عنوان هدیه برات در نظر گرفتیم."
              icon={['fas', 'gift']}
              className="ms-0 me-1"
            />
          )}
          <FontAwesomeIcon icon={['fas', isDeposit ? 'arrow-up' : 'arrow-down']} />
        </span>
      );
    }
  },
  {
    field: 'created_at',
    type: 'string',
    title: 'تاریخ',
    width: 190,
    cellRenderer: (params: { value: string }) => formatDate(params.value)
  }
];
